import api from "./axios";
import { viewDocumentInline } from "./referralApi";

export const getPatientDocuments = (patientId) =>
  api.get(`/api/v1/documents/patient/${patientId}`).then((r) => r.data);

export const uploadPatientDocument = (
  patientId,
  file,
  documentType,
  category,
  expiresAt,
) => {
  const form = new FormData();
  form.append("file", file);
  form.append("patientId", String(patientId));
  form.append("documentType", documentType);
  form.append("category", category);
  if (expiresAt) form.append("expiresAt", expiresAt);
  return api.post("/api/v1/documents/upload", form).then((r) => r.data);
};

export const deletePatientDocument = (documentId, patientId) =>
  api.delete(`/api/v1/documents/${documentId}?patientId=${patientId}`);

export const getInsuranceDocuments = (insuranceId) =>
  api
    .get(`/api/v1/documents/patient-insurance/${insuranceId}`)
    .then((r) => r.data);

export const uploadInsuranceCard = (patientId, insuranceId, file, category) => {
  const form = new FormData();
  form.append("file", file);
  form.append("patientId", String(patientId));
  form.append("patientInsuranceId", String(insuranceId));
  form.append("documentType", "INSURANCE_CARD");
  form.append("category", category);
  return api.post("/api/v1/documents/upload", form).then((r) => r.data);
};

export { viewDocumentInline as viewPatientDocument };
